import { FC } from "react";
import { ChargeBadge } from "@vilocnv/allsetra-core";

export interface IconBatteryLevelProps {
  installationDate: Date;
  lifetimeDays: number;
}

const IconBatteryLevel: FC<IconBatteryLevelProps> = ({
  installationDate,
  lifetimeDays
}) => {
  if (!installationDate || !lifetimeDays) return null;
  function getBatteryPercentage(
    installationDate: Date,
    lifetimeDays: number
  ): number {
    const install = new Date(installationDate);
    const now = new Date();
    const diffTime = now.getTime() - install.getTime();
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    let percent = 100 * (1 - diffDays / lifetimeDays);
    percent = Math.max(0, Math.min(100, percent));
    return Math.round(percent);
  }
  const percent = getBatteryPercentage(installationDate, lifetimeDays);
  return <ChargeBadge percentage={percent}></ChargeBadge>;
};

export default IconBatteryLevel;
